import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-comment-add",
  templateUrl: "./med-icon-comment-add.component.html",
})
export class MedIconCommentAddComponent extends SvgMixinComponent {}
